// Leave GOOGLE_ADS_ID empty to disable Google Ads entirely. Format: AW-XXXXXXXXX
export const GOOGLE_ADS_ID: string = 'AW-16975233207';
export const CONVERSION_LABEL_ORDER = 'tm6lCJqWlbEdELeBtp4_';
// Optional: phone-click conversions are only sent when this is filled in.
export const CONVERSION_LABEL_PHONE = '';
